/**
 * Format a monetary amount with thousands separators and two decimal places.
 * Defaults to LRD (Liberian Dollar) when no currency is specified.
 */
export function formatCurrency(amount: number, currency = 'LRD'): string {
  return `${currency} ${amount.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
}
